import MuiTabList, { TabListProps } from '@mui/lab/TabList';
import { darken, lighten, styled } from '@mui/material';
import { useAppSelector } from 'src/store';

export interface ITabListProps extends TabListProps {}
const CustomTabList = styled(MuiTabList)(({ theme }) => ({
  backgroundColor: theme.palette.mode == "dark" ? darken(theme.palette.primary.main, 0.7) : lighten(theme.palette.primary.main, 0.8),
  borderTopLeftRadius: 4,
  borderTopRightRadius: 4,
  // paddingTop: 2,
  // height: 40,
  minHeight: 0
}));
const TabList = (props: ITabListProps): JSX.Element => {
  const formSize = useAppSelector(s=> s.userLogin.formSize)
  return <CustomTabList sx={{
    padding: 0,
    height: formSize * 3,

  }} {...props} />;
};

export default TabList;
